import React, { Component } from "react";

import he from "he";

import format from "date-fns/format";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";

import { css } from "glamor";
import { Card, Icon } from "antd";
import { CommentForm } from "./Form";

const styles = {
    row: css({
        marginBottom: "1.5em",
    }),
    meta: css({
        marginBottom: ".5rem",
        " .ant-card-meta-title": {
            fontSize: "14px",
            marginBottom: "0 !important",
        },
        " .ant-card-meta-description": {
            fontSize: "10px",
        },
    }),
    avatar: css({
        maxWidth: "32px",
    }),
};

export class CommentItem extends Component {
    state = {
        isReplying: false,
    };

    toggleReplyMode = () => {
        this.setState({ isReplying: !this.state.isReplying });
    };

    handleReplySubmit = comment => {
        if (this.props.onReply) {
            this.props.onReply(comment);
        }
    };

    render() {
        const { name, timestamp, content, children } = this.props;
        const commentContent = he.decode(content);
        const commentDate = new Date(timestamp);
        const subtitle = `${distanceInWordsToNow(commentDate)} at ${format(
            commentDate,
            "hh:mmA"
        )}`;

        let actions = [];
        if (this.props.allowReplies) {
            actions = [
                <div key="reply" onClick={this.toggleReplyMode}>
                    {!this.state.isReplying && (
                        <div>
                            <Icon type="message" /> Reply
                        </div>
                    )}
                </div>,
            ];
        }

        return (
            <Card actions={actions}>
                <Card.Meta
                    className={`${styles.meta}`}
                    avatar={
                        <img
                            {...styles.avatar}
                            src="https://www.gravatar.com/avatar/404?d=mm"
                        />
                    }
                    title={name}
                    description={subtitle}
                />

                <div className={`${styles.row}`}>{commentContent}</div>

                <div className={`${styles.row}`}>{children}</div>

                {this.props.allowReplies && this.state.isReplying ? (
                    <CommentForm
                        isReplying
                        isLoading={this.props.isLoading}
                        onSubmit={this.handleReplySubmit}
                        onCancel={this.toggleReplyMode}
                    />
                ) : null}
            </Card>
        );
    }
}
